import React from "react";
import "./LoadingCircle.css";

export default function LoadingCircle() {
  return (
    <div className="loading-circle-container">
      <div className="loading-circle"></div>
    </div>
  );
}
